import {
  BaseMaskCreateAndDeployResponse,
  ClaimedDatabaseResource,
  CloudAccountApiListAbacAccountsRequest,
  DataAccessGroupInfo,
  DataGroupAccessAssignmentResponse,
  DataGroupApiAddItemsRequest,
  DataGroupApiCreateDataGroupRequest,
  DataGroupApiDeleteDataGroupRequest,
  DataGroupApiGetClaimedResourcesRequest,
  DataGroupApiGetDataAccessGroupsRequest,
  DataGroupApiGetDataGroupRequest,
  DataGroupApiGetIdentitiesUsingDataRoleRequest,
  DataGroupApiGetJitAccessGroupsRequest,
  DataGroupApiListAccessAssignmentsRequest,
  DataGroupApiListDataGroupsRequest,
  DataGroupApiListPolicyRolesRequest,
  DataGroupApiUpdateAccessAssignmentsRequest,
  DataGroupApiUpdateDataGroupRequest,
  DataGroupItemResponse,
  DataGroupPolicyRoleResponse,
  DataGroupResponse,
  IdentityInfo,
  JITAccessGroupInfo,
  MultiBlockPolicyPreviewResponse,
  PageDataGroupListResponse,
  PagePolicyResponse,
  PolicyApiCreateAndDeployBaseMaskPoliciesRequest,
  PolicyApiCreateAndDeployMultiBlockPolicyRequest,
  PolicyApiDeletePolicyRequest,
  PolicyApiGetMultiBlockPolicyRequest,
  PolicyApiGetPolicyRequest,
  PolicyApiListPoliciesRequest,
  PolicyApiPreviewMultiBlockPolicyDdlRequest,
  PolicyApiUpdateAndDeployMultiBlockPolicyRequest,
  PolicyApiUpdatePolicyV2Request,
  PolicyResponse,
  RoleDataGroupsResponse,
  ResourceApiGetProviderStructureRequest,
  ResourceApiListSnowflakeTagsRequest,
  TagsResponse,
} from '@ariksa/abac/api';
import { PageCloudAccountResponse } from '@ariksa/abac/api';
import {
  CloudAccountApiGetCloudAccountsRequest,
  CloudAccountApiOnboardJitAccountRequest,
  CloudAccountApiReadJitConfigRequest,
  OnboardingConfigResponse,
  PageCloudAccountGetResponse,
} from '@ariksa/cloud-account/api';
import {
  DataAccessApiGetAuthorizedIdentitiesRequest,
  DataAccessApiGetDataAccessRolesRequest,
  DataAccessIdentityResponse,
  InsightV2ApiInsightV2AllRequest,
  InsightV2Pagination,
} from '@ariksa/inventory-core/api';
import {
  ItemApiListAllRequestsRequest,
  PageAccessRequestGetResponse,
} from '@ariksa/jit';
import {
  AutoApprovalPolicyResponse,
  CloudAccountDeleteResponse,
  ItemApiCreateAutoApprovalPolicyRequest,
  ItemApiDeleteAccountRequest,
  ItemApiDeleteAutoApprovalPolicyRequest,
  ItemApiEditApproversRequest,
  ItemApiGetAutoApprovalPolicyRequest,
  ItemApiGetJitStatusRolesRequest,
  ItemApiListAccountsRequest,
  ItemApiListAutoApprovalPoliciesRequest,
  ItemApiSaveAutoApprovalConfigurationRequest,
  ItemApiUpdateAutoApprovalPolicyRequest,
  ItemApiUpdateJitRolesRequest,
  JitEnabledStatusGetResponse,
  PageCloudAccountInfoGetResponse,
  ResponseUpdateJitRolesV1JitAccountsAccountIdJitRolesPut,
} from '@ariksa/jit/api';
import { call } from 'redux-saga/effects';
import { QueryContext } from 'services/utils/QueryContext';
import { takeEveryAction } from 'services/utils/takeEveryAction';
import { takeLatestAction } from 'services/utils/takeLatestAction';

import { authOptions } from 'api/auth';
import {
  UserService,
  UserServiceListRequest,
  UserServiceListResponse,
} from 'api/auth/api.pb';
import { Abac, CloudAccountService, JitService } from 'api/services';
import { actions } from 'containers/Jit/Setup/slice';

export function* jitSetupSaga() {
  yield takeLatestAction(actions.getCloudAccounts, doGetCloudAccounts);
  yield takeLatestAction(
    actions.getDataAccessCloudAccounts,
    doGetDataAccessCloudAccounts,
  );
  yield takeLatestAction(actions.getSnowflakeRoles, doGetSnowflakeRoles);
  yield takeLatestAction(actions.getDataGroupsByRole, doGetDataGroupsByRole);
  yield takeLatestAction(actions.getClaimedResources, doGetClaimedResources);
  yield takeLatestAction(actions.listSnowflakeTags, doListSnowflakeTags);
  yield takeLatestAction(
    actions.createAndDeployBaseMaskPolicies,
    doCreateAndDeployBaseMaskPolicies,
  );
  yield takeLatestAction(actions.getDataPolicies, doGetDataPolicies);
  yield takeLatestAction(actions.createPolicy, doCreatePolicy);
  yield takeLatestAction(actions.deletePolicy, doDeletePolicy);
  yield takeLatestAction(actions.updatePolicy, doUpdatePolicy);
  yield takeLatestAction(actions.getPolicyById, doGetPolicyById);
  yield takeLatestAction(actions.getMultiBlockPolicy, doGetMultiBlockPolicy);
  yield takeLatestAction(
    actions.updateAndDeployMultiBlockPolicy,
    doUpdateAndDeployMultiBlockPolicy,
  );
  yield takeLatestAction(actions.getStructure, doGetProviderStructure);
  yield takeLatestAction(actions.getTagKeyValues, doGetTagKeyValues);
  yield takeLatestAction(actions.generatePolicy, doGeneratePolicy);
  yield takeLatestAction(
    actions.getIdentitiesUsingDataRole,
    doGetIdentitiesUsingDataRole,
  );
  yield takeLatestAction(actions.getDataAccessGroups, doGetDataAccessGroups);
  yield takeLatestAction(actions.createDataGroup, doCreateDataGroup);
  yield takeLatestAction(actions.deleteDataGroup, doDeleteDataGroup);
  yield takeLatestAction(actions.updateDataGroup, doUpdateDataGroup);
  yield takeLatestAction(actions.addDataGroupItems, doAddDataGroupItems);
  yield takeLatestAction(actions.getDataGroup, doGetDataGroup);
  yield takeEveryAction(actions.getDataGroupRoles, doGetDataGroupRoles);
  yield takeLatestAction(
    actions.getDataAccessRolesOptions,
    doGetDataAccessRolesOptions,
  );
  yield takeLatestAction(actions.getUsers, doGetAuthorizedIdentities);
  yield takeLatestAction(
    actions.getAuthorizedIdentities,
    doGetAuthorizedIdentities,
  );
  yield takeLatestAction(
    actions.getCloudRolesWithMasksForADataGroup,
    doGetCloudRolesWithMasksForADataGroup,
  );
  yield takeLatestAction(actions.saveConfiguration, doSaveConfiguration);
  yield takeLatestAction(actions.getConfiguration, doGetConfiguration);
  yield takeLatestAction(
    actions.getJitEnabledOktaGroups,
    doGetJitEnabledOktaGroups,
  );
  yield takeLatestAction(actions.getAuthorizedGroups, doGetAuthorizedGroups);
  yield takeLatestAction(actions.getDataAccessRoles, doGetDataAccessRoles);

  yield takeLatestAction(actions.editJitApprover, doEditJitApprover);
  yield takeLatestAction(actions.addJitApprover, doAddJitApprover);
  yield takeLatestAction(actions.getJitAccounts, doGetJitAccounts);
  yield takeLatestAction(actions.getAbacAccounts, doGetAbacAccounts);
  yield takeLatestAction(actions.getJitAccountList, doGetJitAccounts);
  yield takeLatestAction(actions.getJitApproverList, doGetJitApproverList);
  yield takeLatestAction(actions.deleteJitAccount, doDeleteJitAccount);

  yield takeLatestAction(
    actions.getJitApproveRequests,
    doGetJitApproveRequests,
  );

  yield takeLatestAction(actions.getOnboardingConfig, doGetOnboardingConfig);

  yield takeLatestAction(actions.getRoles, doGetRoles);
  yield takeLatestAction(actions.updateJitRoles, doUpdateJitRoles);

  yield takeLatestAction(actions.addJitAccount, doAddJitAccount);
  yield takeLatestAction(actions.configureJitApproval, doConfigureJITApproval);
  // The approval-policy screens below have no backing API: auto-approval is now
  // one max duration per account, not a policy with its own id.
  yield takeLatestAction(actions.getApprovalPolicies, doGetJITApprovalPolicies);
  yield takeLatestAction(actions.getApprovalPolicy, doGetJITApprovalPolicy);
  yield takeLatestAction(
    actions.deleteApprovalPolicy,
    doDeleteJITApprovalPolicy,
  );
  yield takeLatestAction(
    actions.updateApprovalPolicy,
    doUpdateJITApprovalPolicy,
  );
  yield takeLatestAction(actions.getDataGroups, doGetDataGroups);
}

export function* doGetCloudAccounts(
  ctx: QueryContext<
    PageCloudAccountGetResponse,
    CloudAccountApiGetCloudAccountsRequest
  >,
) {
  yield ctx.fetch(() =>
    CloudAccountService.CloudAccount.getCloudAccounts(ctx.params),
  );
}

export function* doEditJitApprover(
  ctx: QueryContext<any, ItemApiEditApproversRequest>,
) {
  yield ctx.fetch(() => JitService.Jit.editApprovers(ctx.params));
}

export function* doAddJitApprover(
  ctx: QueryContext<string, ItemApiEditApproversRequest>,
) {
  yield ctx.fetch(() => JitService.Jit.editApprovers(ctx.params));
}

export function* doGetJitAccounts(
  ctx: QueryContext<
    PageCloudAccountInfoGetResponse,
    ItemApiListAccountsRequest
  >,
) {
  yield ctx.fetch(() => JitService.Jit.listAccounts(ctx.params));
}

export function* doGetAbacAccounts(
  ctx: QueryContext<
    PageCloudAccountResponse,
    CloudAccountApiListAbacAccountsRequest
  >,
) {
  yield ctx.fetch(() => Abac.CloudAccounts.listAbacAccounts(ctx.params));
}

export function* doGetJitApproverList(
  ctx: QueryContext<UserServiceListResponse, UserServiceListRequest>,
) {
  yield ctx.fetch(() => {
    return UserService.List(ctx.params, authOptions()).then(r => {
      return { data: r };
    });
  });
}

export function* doDeleteJitAccount(
  ctx: QueryContext<CloudAccountDeleteResponse, ItemApiDeleteAccountRequest>,
) {
  yield ctx.fetch(() => JitService.Jit.deleteAccount(ctx.params));
}

export function* doGetJitApproveRequests(
  ctx: QueryContext<
    PageAccessRequestGetResponse,
    ItemApiListAllRequestsRequest
  >,
) {
  yield ctx.fetch(() => JitService.Jit.listAllRequests(ctx.params), {
    cacheTime: 1000 * 30,
  });
}

export function* doGetOnboardingConfig(
  ctx: QueryContext<
    OnboardingConfigResponse,
    CloudAccountApiReadJitConfigRequest
  >,
) {
  yield ctx.fetch(() =>
    CloudAccountService.CloudAccount.readJitConfig(ctx.params),
  );
}

export function* doGetRoles(
  ctx: QueryContext<
    JitEnabledStatusGetResponse,
    ItemApiGetJitStatusRolesRequest
  >,
) {
  yield ctx.fetch(() => JitService.Jit.getJitStatusRoles(ctx.params));
}

export function* doUpdateJitRoles(
  ctx: QueryContext<
    ResponseUpdateJitRolesV1JitAccountsAccountIdJitRolesPut,
    ItemApiUpdateJitRolesRequest
  >,
) {
  yield ctx.fetch(() => JitService.Jit.updateJitRoles(ctx.params));
}

export function* doAddJitAccount(
  ctx: QueryContext<any, CloudAccountApiOnboardJitAccountRequest>,
) {
  yield ctx.fetch(() =>
    CloudAccountService.CloudAccount.onboardJitAccount(ctx.params),
  );
}

export function* doConfigureJITApproval(
  ctx: QueryContext<any, ItemApiSaveAutoApprovalConfigurationRequest>,
) {
  yield ctx.fetch(() =>
    JitService.Jit.saveAutoApprovalConfiguration(ctx.params),
  );
}

export function* doGetJITApprovalPolicies(
  ctx: QueryContext<
    AutoApprovalPolicyResponse[],
    ItemApiListAutoApprovalPoliciesRequest
  >,
) {
  yield ctx.fetch(() => JitService.Jit.listAutoApprovalPolicies(ctx.params));
}

export function* doGetJITApprovalPolicy(
  ctx: QueryContext<
    AutoApprovalPolicyResponse,
    ItemApiGetAutoApprovalPolicyRequest
  >,
) {
  yield ctx.fetch(() => JitService.Jit.getAutoApprovalPolicy(ctx.params));
}

export function* doUpdateJITApprovalPolicy(
  ctx: QueryContext<any, ItemApiUpdateAutoApprovalPolicyRequest>,
) {
  yield ctx.fetch(() => JitService.Jit.updateAutoApprovalPolicy(ctx.params));
}

export function* doDeleteJITApprovalPolicy(
  ctx: QueryContext<any, ItemApiDeleteAutoApprovalPolicyRequest>,
) {
  yield ctx.fetch(() => JitService.Jit.deleteAutoApprovalPolicy(ctx.params));
}

function* doGetDataAccessCloudAccounts(
  ctx: QueryContext<
    PageCloudAccountResponse,
    CloudAccountApiListAbacAccountsRequest
  >,
) {
  yield call(ctx.fetch, () => Abac.CloudAccounts.listAbacAccounts(ctx.params));
}

function* doGetSnowflakeRoles(
  ctx: QueryContext<InsightV2Pagination, InsightV2ApiInsightV2AllRequest>,
) {
  yield call(ctx.fetch, () =>
    InventoryService.InsightV2.insightV2All(ctx.params),
  );
}

function* doGetDataGroupsByRole(ctx: QueryContext<RoleDataGroupsResponse[]>) {
  yield call(ctx.fetch, () => Abac.DataGroup.getDataGroupsByRole());
}

function* doGetClaimedResources(
  ctx: QueryContext<
    ClaimedDatabaseResource[],
    DataGroupApiGetClaimedResourcesRequest
  >,
) {
  yield call(ctx.fetch, () => Abac.DataGroup.getClaimedResources(ctx.params));
}

function* doListSnowflakeTags(
  ctx: QueryContext<TagsResponse, ResourceApiListSnowflakeTagsRequest>,
) {
  yield call(ctx.fetch, () => Abac.Resources.listSnowflakeTags(ctx.params));
}

function* doCreateAndDeployBaseMaskPolicies(
  ctx: QueryContext<
    BaseMaskCreateAndDeployResponse,
    PolicyApiCreateAndDeployBaseMaskPoliciesRequest
  >,
) {
  yield call(ctx.fetch, () =>
    Abac.Policy.createAndDeployBaseMaskPolicies(ctx.params),
  );
}

function* doGetPolicyById(
  ctx: QueryContext<PolicyResponse, PolicyApiGetPolicyRequest>,
) {
  yield call(ctx.fetch, () => Abac.Policy.getPolicy(ctx.params));
}

function* doGetMultiBlockPolicy(
  ctx: QueryContext<any, PolicyApiGetMultiBlockPolicyRequest>,
) {
  yield call(ctx.fetch, () => Abac.Policy.getMultiBlockPolicy(ctx.params));
}

function* doDeletePolicy(ctx: QueryContext<any, PolicyApiDeletePolicyRequest>) {
  yield call(ctx.fetch, () => Abac.Policy.deletePolicy(ctx.params));
}

function* doUpdatePolicy(
  ctx: QueryContext<any, PolicyApiUpdatePolicyV2Request>,
) {
  yield call(ctx.fetch, () => Abac.Policy.updatePolicyV2(ctx.params));
}

function* doUpdateAndDeployMultiBlockPolicy(
  ctx: QueryContext<any, PolicyApiUpdateAndDeployMultiBlockPolicyRequest>,
) {
  yield call(ctx.fetch, () =>
    Abac.Policy.updateAndDeployMultiBlockPolicy(ctx.params),
  );
}

function* doGetDataPolicies(
  ctx: QueryContext<PagePolicyResponse, PolicyApiListPoliciesRequest>,
) {
  yield call(ctx.fetch, () => Abac.Policy.listPolicies(ctx.params));
}

function* doCreatePolicy(
  ctx: QueryContext<any, PolicyApiCreateAndDeployMultiBlockPolicyRequest>,
) {
  yield call(ctx.fetch, () =>
    Abac.Policy.createAndDeployMultiBlockPolicy(ctx.params),
  );
}

function* doGetProviderStructure(
  ctx: QueryContext<
    Record<string, any>,
    ResourceApiGetProviderStructureRequest
  >,
) {
  yield call(ctx.fetch, () => Abac.Resources.getProviderStructure(ctx.params));
}

function* doGetTagKeyValues(
  ctx: QueryContext<TagsResponse, ResourceApiListSnowflakeTagsRequest>,
) {
  yield call(ctx.fetch, () => Abac.Resources.listSnowflakeTags(ctx.params));
}

function* doGeneratePolicy(
  ctx: QueryContext<
    MultiBlockPolicyPreviewResponse,
    PolicyApiPreviewMultiBlockPolicyDdlRequest
  >,
) {
  yield call(ctx.fetch, () =>
    Abac.Policy.previewMultiBlockPolicyDdl(ctx.params),
  );
}

function* doGetIdentitiesUsingDataRole(
  ctx: QueryContext<
    IdentityInfo[],
    DataGroupApiGetIdentitiesUsingDataRoleRequest
  >,
) {
  yield call(ctx.fetch, () =>
    Abac.DataGroup.getIdentitiesUsingDataRole(ctx.params),
  );
}

function* doGetDataAccessGroups(
  ctx: QueryContext<
    PageDataGroupListResponse,
    DataGroupApiListDataGroupsRequest
  >,
) {
  yield call(ctx.fetch, () => Abac.DataGroup.listDataGroups(ctx.params));
}

function* doCreateDataGroup(
  ctx: QueryContext<DataGroupResponse, DataGroupApiCreateDataGroupRequest>,
) {
  yield call(ctx.fetch, () => Abac.DataGroup.createDataGroup(ctx.params));
}

function* doDeleteDataGroup(
  ctx: QueryContext<DataGroupResponse, DataGroupApiDeleteDataGroupRequest>,
) {
  yield call(ctx.fetch, () => Abac.DataGroup.deleteDataGroup(ctx.params));
}

function* doUpdateDataGroup(
  ctx: QueryContext<DataGroupResponse, DataGroupApiUpdateDataGroupRequest>,
) {
  yield call(ctx.fetch, () => Abac.DataGroup.updateDataGroup(ctx.params));
}

function* doAddDataGroupItems(
  ctx: QueryContext<DataGroupItemResponse[], DataGroupApiAddItemsRequest>,
) {
  yield call(ctx.fetch, () => Abac.DataGroup.addItems(ctx.params));
}

function* doGetDataGroup(
  ctx: QueryContext<DataGroupResponse, DataGroupApiGetDataGroupRequest>,
) {
  yield call(ctx.fetch, () => Abac.DataGroup.getDataGroup(ctx.params));
}

function* doGetCloudRolesWithMasksForADataGroup(
  ctx: QueryContext<
    DataGroupPolicyRoleResponse[],
    DataGroupApiListPolicyRolesRequest
  >,
) {
  yield call(ctx.fetch, () => Abac.DataGroup.listPolicyRoles(ctx.params));
}

function* doGetDataGroupRoles(
  ctx: QueryContext<
    DataAccessGroupInfo[],
    DataGroupApiGetDataAccessGroupsRequest
  >,
) {
  yield call(ctx.fetch, () => Abac.DataGroup.getDataAccessGroups(ctx.params));
}

function* doGetAuthorizedIdentities(
  ctx: QueryContext<
    DataAccessIdentityResponse[],
    DataAccessApiGetAuthorizedIdentitiesRequest
  >,
) {
  yield call(ctx.fetch, () =>
    InventoryService.DataAccess.getAuthorizedIdentities(ctx.params),
  );
}

function* doGetDataAccessRolesOptions(
  ctx: QueryContext<
    DataAccessIdentityResponse[],
    DataAccessApiGetDataAccessRolesRequest
  >,
) {
  yield call(ctx.fetch, () =>
    InventoryService.DataAccess.getDataAccessRoles(ctx.params),
  );
}

function* doSaveConfiguration(
  ctx: QueryContext<
    DataGroupAccessAssignmentResponse[],
    DataGroupApiUpdateAccessAssignmentsRequest
  >,
) {
  yield call(ctx.fetch, () =>
    Abac.DataGroup.updateAccessAssignments(ctx.params),
  );
}

function* doGetConfiguration(
  ctx: QueryContext<
    DataGroupAccessAssignmentResponse[],
    DataGroupApiListAccessAssignmentsRequest
  >,
) {
  yield call(ctx.fetch, () => Abac.DataGroup.listAccessAssignments(ctx.params));
}

function* doGetJitEnabledOktaGroups(
  ctx: QueryContext<
    JITAccessGroupInfo[],
    DataGroupApiGetJitAccessGroupsRequest
  >,
) {
  yield call(ctx.fetch, () => Abac.DataGroup.getJitAccessGroups(ctx.params));
}

function* doGetAuthorizedGroups(
  ctx: QueryContext<
    JITAccessGroupInfo[],
    DataGroupApiGetJitAccessGroupsRequest
  >,
) {
  yield call(ctx.fetch, () => Abac.DataGroup.getJitAccessGroups(ctx.params));
}

function* doGetDataAccessRoles(
  ctx: QueryContext<
    DataGroupAccessAssignmentResponse[],
    DataGroupApiListAccessAssignmentsRequest
  >,
) {
  yield call(ctx.fetch, () => Abac.DataGroup.getDataAccessGroups(ctx.params));
}

function* doGetDataGroups(
  ctx: QueryContext<
    PageDataGroupListResponse,
    DataGroupApiListDataGroupsRequest
  >,
) {
  yield ctx.fetch(() => Abac.DataGroup.listDataGroups(ctx.params));
}
